import React, { FC, useContext, useState } from "react";
import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import "./License.css";
import Button from "../../UiLib/Button/Button";
import Cross from "../../../assets/images/cross.svg";
import Upload from "../../../assets/upload.svg";
import Cancel from "../../../assets/cancelGreey.svg";
import { formatBytes } from "../../../helpers/formatBytes";
import { AppContext } from "../../../App";
import SmallProgressBar from "../../Shared/ProgressBar/SmallProgressBar";
import TextWithCopy from "../../Shared/TextWithCopy/TextWithCopy";

interface ILicenseUploadProps {
    onClose?: () => void;
    onActivate: (file: File) => void;
    showCloseElements?: boolean;
    serverId?: string;
}

const LicenseUpload: FC<ILicenseUploadProps> = ({
    onClose,
    onActivate,
    showCloseElements,
    serverId,
}) => {
    const [file, setFile] = useState<File>();
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const { showToast } = useContext(AppContext);

    const handleActivate = () => {
        if (file === undefined) {
            showToast("Загрузите файл лицензии");
            return;
        } else {
            onActivate(file);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        setUploadProgress(0);
        if (file) {
            if (file.type !== ".lic" && !file.name.includes(".lic")) {
                showToast("Неверное расширение файла лицензии");
            } else {
                setFile(file);
            }
        }
        setTimeout(() => setUploadProgress(100), 100);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setUploadProgress(0);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            if (file.type !== ".lic" && !file.name.includes(".lic")) {
                showToast("Неверное расширение файла лицензии");
            } else {
                setFile(e.dataTransfer.files[0]);
            }
            e.dataTransfer.clearData();
        }
        setTimeout(() => setUploadProgress(100), 100);
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    return (
        <WidgetContainer className="activate-license-container">
            <div className="activate-license-header">
                <h1 className="activate-license-header-text">
                    Активация лицензии
                </h1>
                {showCloseElements ? (
                    <Button
                        callBack={() => (onClose ? onClose() : null)}
                        image={Cross}
                    />
                ) : null}
            </div>
            {serverId ? (
                <TextWithCopy text={serverId}/>
            ) : null}
            <div onDrop={handleDrop} onDragOver={handleDragOver}>
                <div className="license-file-upload">
                    <img src={Upload} className="upload-icon" />
                    <p>
                        Перенесите или{" "}
                        <label
                            htmlFor="license-file-input"
                            className="license-file-upload-load-text"
                        >
                            загрузите
                        </label>{" "}
                        файл лицензии сюда
                    </p>
                </div>
                <input
                    type="file"
                    id="license-file-input"
                    accept=".lic"
                    onChange={handleChange}
                />
            </div>
            {file !== undefined ? (
                <div className="uploaded-file-container">
                    <div className="uploaded-file-container-filename">
                        <div className="file-name">{file.name}</div>
                        <button
                            className="img-button"
                            onClick={() => setFile(undefined)}
                        >
                            <img src={Cancel} />
                        </button>
                    </div>
                    <div className="uploaded-file-container-filesize">
                        {formatBytes(file.size)}
                    </div>
                    <div>
                        <SmallProgressBar progress={uploadProgress} />
                    </div>
                </div>
            ) : null}
            <div className="activate-license-buttons">
                <button
                    className="green-button"
                    style={file === undefined ? { opacity: "50%" } : {}}
                    onClick={handleActivate}
                >
                    Активировать
                </button>
                {showCloseElements ? (
                    <button
                        className="light-blue-button-blue-text"
                        onClick={onClose}
                    >
                        Отмена
                    </button>
                ) : null}
            </div>
        </WidgetContainer>
    );
};

export default LicenseUpload;
